module.exports = __webpack_public_path__ + "static/media/login_background_mobile.041c00d7.png";